<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.122"
    height="15.899"
    viewBox="0 0 14.122 15.899"
  >
    <g transform="translate(-1102.654 -586.239)">
      <path
        d="M1116.019,601.316l-.979-.208a32.974,32.974,0,0,0,.72-7.7,5.775,5.775,0,0,0-4.188-5.975,1.893,1.893,0,0,1-.281-.048c-.855-.187-3.458-.762-5.77,2.679-2.742,4.083-1.637,9.374-1.627,9.426l-.976.213c-.051-.232-1.211-5.753,1.773-10.2,1.782-2.654,4.066-3.7,6.8-3.1l.028-.022.242.064a6.761,6.761,0,0,1,5,6.983A33.877,33.877,0,0,1,1116.019,601.316Z"
      />
      <rect
        width="0.998"
        height="5.848"
        transform="matrix(0.483, -0.875, 0.875, 0.483, 1107.316, 596.894)"
      />
      <path
        d="M1107.573,599.832l-.48-.877,5.347-2.937.48.877Z"
      />
      <rect
        width="0.999"
        height="5.134"
        transform="matrix(0.507, -0.862, 0.862, 0.507, 1107.671, 599.533)"
      />
      <rect
        width="5.572"
        height="1"
        transform="translate(1107.091 601.27) rotate(-29.87)"
      />
    </g>
  </svg>
</template>
